module.exports = __webpack_public_path__ + "img/benlose_fugle.884194dd.jpg";